module.exports = __webpack_public_path__ + "assets/img/pazq.029fbf33.png";